import { Component, inject } from '@angular/core';
import { OnInit, AfterViewInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AsyncPipe, CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CompanyInterface } from '@app/interface/company';
import { MatTableDataSource } from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import { SavedProductsApi } from '@app/services/savedproducts-api.service';
import {
  PaginatedResponse,
  RecursiveInterface,
} from '@app/services/base-authenticated.service';
import { NgForm } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import {
  MatPaginator,
  MatPaginatorModule,
  PageEvent,
} from '@angular/material/paginator';
import { ViewChild } from '@angular/core';
// import { LayoutComponent } from '../layout/layout.component';
import { ActivatedRoute } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import { SavedProductInterface } from '@app/interface/savedproduct';
import { Router } from '@angular/router';
import { ConfirmInvoiceDeleteComponent } from '@app/confirm-delete-dialog/confirm-delete-dialog.component';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { LoadingDialogComponent } from '@app/loading-dialog/loading-dialog.component';
import { ChangeDetectorRef } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BackHeaderComponent } from '@app/back-header/back-header.component';
import { ToastService } from '@app/services/toast.service';

@Component({
  selector: 'izy-savedproducts',
  imports: [
    CommonModule,
    MatTableModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    // AsyncPipe,
    // CompanyAutocompleteComponent,
    MatPaginatorModule,
    MatPaginator,
    // LayoutComponent,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatListModule,
    MatMenuModule,
    MatChipOption,
    MatChipsModule,
    MatProgressSpinnerModule,
    BackHeaderComponent,
  ],
  templateUrl: './savedproducts.component.html',
  styleUrl: './savedproducts.component.scss',
})
export class SavedProductsComponent implements OnInit {
  private toast = inject(ToastService);
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  displayedColumns: string[] = [
    'Actions',
    'name',
    'type',
    'units',
    'unit_price',
    'description',
    'iva_percentage',
  ];

  newSavedProduct: Partial<SavedProductInterface> = {
    id: 1,
    name: '',
    type: 'SERVIZIO',
    units: '',
    unit_price: 0,
    iva_percentage: 10,
    description: '',

    organization_id: 1,
  };

  constructor(
    private SavedProductsApi: SavedProductsApi,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
  ) {}

  filterOptions = [
    { name: 'Tutti', value: 'all' },
    { name: 'Servizi', value: 'SERVIZIO' },
    { name: 'Prodotti', value: 'PRODOTTO' },
  ];
  selectedFilter = 'all';

  applyTypeFilter(filterValue: string): void {
    this.selectedFilter = filterValue;

    if (filterValue === 'all') {
      // Show all companies
      this.savedProductSource.filter = '';
    } else {
      // Filter by type
      this.savedProductSource.filterPredicate = (
        data: SavedProductInterface,
        filter: string,
      ) => {
        return data.type === filter;
      };
      this.savedProductSource.filter = filterValue;
    }

    // Update the paginator length to reflect filtered results
    if (this.paginator) {
      this.paginator.firstPage();
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();

    // Combine search filter with type filter
    this.savedProductSource.filterPredicate = (
      data: SavedProductInterface,
      filter: string,
    ) => {
      const typeMatch =
        this.selectedFilter === 'all' || data.type === this.selectedFilter;

      return typeMatch;
    };

    this.savedProductSource.filter = filterValue || ' '; // Use space if empty to trigger filtering
  }

  savedProductSource = new MatTableDataSource<SavedProductInterface>([]);
  isLoading: boolean = false; // Initialize as false by default
  errorMessage: string | null = null;

  ngOnInit() {
    this.loadSavedProducts();

    // Initialize filteredOptions after companies are loaded
    // this.filteredOptions = this.myControl.valueChanges.pipe(
    //   startWith(''),
    //   debounceTime(300),
    //   map((value: any) => this._filter(value || ''))
    // );

    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    this.paginator._intl.itemsPerPageLabel = 'Elementi per pagina:';
    this.paginator._intl.nextPageLabel = 'Pagina successiva';
    this.paginator._intl.previousPageLabel = 'Pagina precedente';
    this.paginator._intl.firstPageLabel = 'Prima pagina';
    this.paginator._intl.lastPageLabel = 'Ultima pagina';

    this.paginator._intl.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number,
    ) => {
      if (length === 0 || pageSize === 0) {
        return `0 di ${length}`;
      }

      const startIndex = page * pageSize;
      const endIndex =
        startIndex < length
          ? Math.min(startIndex + pageSize, length)
          : startIndex + pageSize;

      return `${startIndex + 1} - ${endIndex} di ${length}`;
    };
  }

  private loadSavedProducts(sortDirection: 'asc' | 'desc' = 'asc') {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.isLoading = true;
    this.errorMessage = null;

    const filterParams: any = {
      ordering: sortDirection === 'asc' ? 'name' : '-name',
    };
    filterParams.is_deleted = false;

    this.SavedProductsApi.getAllSavedProducts<SavedProductInterface>(
      organization_id,
      filterParams,
    ).subscribe({
      next: (response: RecursiveInterface<SavedProductInterface>) => {
        if (response.completed) {
          // All companies loaded across all pages
          const AllSavedProducts = response.results;

          // Update data source with all companies
          this.savedProductSource.data = AllSavedProducts;
          this.savedProductSource.paginator = this.paginator;

          // Extract company names from the complete dataset
          // this.savedProductSource = AllSavedProducts.map(
          //   (savedProduct) => savedProduct.name
          // );

          // Update pagination length with total count
          if (response.count !== undefined) {
            this.paginator.length = response.count;
          }

          console.log('All products loaded', AllSavedProducts.length);
        } else {
          // Optional: Show loading progress
          console.log(
            `Loaded ${response.results.length} saved products so far...`,
          );
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error('Error loading products:', err);
        this.showErrorMessage('Errore durante il caricamento.');
        this.cdr.detectChanges();
      },
    });
  }

  addNewSavedProduct(form?: NgForm) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    // validate required fields
    console.log(
      !this.newSavedProduct.organization_id || !this.newSavedProduct.id,
    );
    console.log(this.newSavedProduct);
    this.SavedProductsApi.createSavedProduct(
      organization_id,
      this.newSavedProduct,
    ).subscribe({
      next: (createdSavedProduct: SavedProductInterface) => {
        this.savedProductSource.data = [
          ...this.savedProductSource.data,
          createdSavedProduct,
        ];
        this.showSuccessMessage(
          `${createdSavedProduct.name} (ID ${createdSavedProduct.id}) added successfully!`,
        );
        this.resetForm(form);
      },
      error: (err: any) => {
        console.error('Error creating company:', err);
        this.showErrorMessage('Errore durante la creazione del cliente.');
      },
    });
  }

  onRowClick(savedproduct: SavedProductInterface) {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/savedproduct`, savedproduct.id]);
  }

  navigateToNewSavedProduct() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    // console.log(org_id);
    this.router.navigate([`/${org_id}/new_savedproduct`]);
  }

  // soft delete
  async deleteSavedProduct(savedProduct: SavedProductInterface) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    const dialogRef = this.dialog.open(ConfirmInvoiceDeleteComponent, {
      width: '90vw',
      maxWidth: '400px',
      /* Niente altezza fissa: con la barra azioni panna a filo bordo e' il
         contenuto a dettare l'altezza. Lo stile della superficie e' in
         styles.scss (.izy-confirm-dialog-panel): il dialog vive nell'overlay
         CDK, fuori dai componenti. */
      maxHeight: '90vh',
      panelClass: 'izy-confirm-dialog-panel',
      data: {
        // invoiceName: invoice.invoice_name,
        /* Veste d'allarme: il prodotto salvato non torna indietro. Il dialog
           si mette da se' la panelClass .izy-danger-dialog-panel. */
        danger: true,
        title: 'Elimina prodotto o servizio',
        message:
          'Questo prodotto o servizio non sarà più disponibile durante la creazione delle fatture.', // Custom message
        checkboxLabel: 'Confermo di voler eliminare e accetto', // Custom checkbox label
      },
    });

    const result = await dialogRef.afterClosed().toPromise();

    if (result) {
      // User confirmed deletion - show loading dialog
      const loadingDialogRef = this.dialog.open(LoadingDialogComponent, {
        width: '90vw',
        maxWidth: '400px',
        height: '300px',
        disableClose: true, // Prevent closing during loading
      });

      // Simulate delay
      try {
        // Combine fake delay with actual API call
        await Promise.all([
          new Promise((resolve) => setTimeout(resolve, 700)), // .7-second delay
          this.SavedProductsApi.updateSavedProductDetails(
            organization_id,
            savedProduct.id,
            {
              is_deleted: true,
            },
          ).toPromise(),
        ]);

        // Close loading dialog
        loadingDialogRef.close();

        // Remove from local data
        // this.dataSource.data = this.dataSource.data.filter(
        //   (i) => i.id !== invoice.id
        // );
        // this.filteredInvoices = this.filteredInvoices.filter(
        //   (i) => i.id !== invoice.id
        // );

        this.showSuccessMessage(`${savedProduct.name} eliminato con successo!`);
      } catch (err: any) {
        // Close loading dialog on error
        loadingDialogRef.close();

        console.error('Error deleting invoice:', err);
        this.showErrorMessage('Impossibile eliminare.');
      }
    }
  }

  backToDashboard(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/dashboard`]);
  }

  formatTableAmount(amount: number, currency: string = 'EUR'): string {
    const formatted = new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

    return formatted;
  }

  private showSuccessMessage(message: string): void {
    this.toast.success(message);
  }

  private resetForm(form?: NgForm) {
    if (form) {
      form.resetForm();
    }
    ((this.newSavedProduct = {
      id: 1,
      name: '',
      organization_id: 1,

      units: '',
      unit_price: 0,
      iva_percentage: 10,
      description: '',
    }),
      console.log('reset'));
  }

  private showErrorMessage(message: string): void {
    this.toast.error(message);
  }
}
